import { ReactNode } from 'react';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from '@azure/msal-browser';
import { msalConfig, isAuthConfigured } from '../../config/authConfig';

// Crear instancia de MSAL
let msalInstance: PublicClientApplication | null = null;

if (isAuthConfigured()) {
  msalInstance = new PublicClientApplication(msalConfig);

  // Manejar eventos de autenticación
  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      msalInstance?.setActiveAccount(payload.account);
    }
  });

  // Establecer cuenta activa si existe
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }
}

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  // Si no está configurado, renderizar sin autenticación
  if (!isAuthConfigured() || !msalInstance) {
    console.warn('Azure AD no está configurado. La aplicación funcionará sin autenticación.');
    return <>{children}</>;
  }

  return (
    <MsalProvider instance={msalInstance}>
      {children}
    </MsalProvider>
  );
}

export { msalInstance };
